export enum Locale {
  EN = 'en',
  FI = 'fi-FI',
  SV = 'sv-FI',
}
